import { css } from 'styled-components';

export const viewportSizes = {
    XS: 480,
    S: 600,
    M: 768,
    L: 900,
    XL: 1008,
    XXL: 1280,
    MAXIMUM: 1600,
};

const makeFunction = (size: number): TaggedTemplateFunction => {
    return (...args) => css`
        @media (min-width: ${size / 16}em) {
            ${css(...args)};
        }
    `;
};

/**
 * breakpoint functions to use in Styled component CSS
 */
export const breakpoints: ISizeFunctions = {
    XS: makeFunction(viewportSizes.XS),
    S: makeFunction(viewportSizes.S),
    M: makeFunction(viewportSizes.M),
    L: makeFunction(viewportSizes.L),
    XL: makeFunction(viewportSizes.XL),
    XXL: makeFunction(viewportSizes.XXL),
    MAXIMUM: makeFunction(viewportSizes.MAXIMUM),
};

type TaggedTemplateFunction = (literals: TemplateStringsArray, ...placeholders: string[]) => any;

interface ISizeFunctions {
    XS: TaggedTemplateFunction;
    S: TaggedTemplateFunction;
    M: TaggedTemplateFunction;
    L: TaggedTemplateFunction;
    XL: TaggedTemplateFunction;
    XXL: TaggedTemplateFunction;
    MAXIMUM: TaggedTemplateFunction;
}
